import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { useMoneyMask } from '@redlink/core';

export const StatTileItem = memo(
  ({ width = 100, title, value, IconComponent }) => {
    const { styles } = useStyle();
    const { getValue } = useMoneyMask();
    return (
      <View style={styles.container}>
        {IconComponent}
        <Space size={8} />
        <Text style={styles.title} numberOfLines={1}>
          {title}
        </Text>
        <Space />
        <Text style={styles.value}>{getValue(value)}</Text>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    flex: 1,
    fontSize: 16,
    textAlign: 'left',
    color: colors.black
  },
  value: {
    color: colors.blue1,
    fontWeight: 'bold',
  },
}));
